import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PendingTransfers({ onChange }) {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/pending").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try { await api.post(`/admin/transfers/${id}/${action}`); toast.success(`Transfer ${action === "approve" ? "approved" : "rejected"}`); load(); onChange(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="tile" data-testid="pending-transfers-panel">
      <div className="divide-y">
        {rows.map((t) => (
          <div key={t.id} className="px-6 py-4 flex flex-wrap gap-4 items-center justify-between" data-testid={`pending-row-${t.id}`}>
            <div>
              <div className="font-semibold text-[var(--navy)]">{t.description}</div>
              <div className="text-xs text-slate-500">{t.user_name} (@{t.username}) · {fmtDate(t.date)} {t.memo ? `· ${t.memo}` : ""}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-display font-semibold">{t.amount >= 0 ? "+" : "-"}{money(Math.abs(t.amount))}</span>
              <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => act(t.id, "approve")} data-testid={`approve-${t.id}`}>Approve</Button>
              <Button size="sm" variant="outline" className="border-[var(--red)] text-[var(--red)]" onClick={() => act(t.id, "reject")} data-testid={`reject-${t.id}`}>Reject</Button>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="p-10 text-center text-slate-500 text-sm" data-testid="pending-empty">No transfers awaiting verification.</div>}
      </div>
    </div>
  );
}
